<div class="container-fluid">
  <div class="row">
    <div class="col-xl-1"></div>

    <div class="col-xl-10">

      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">

            <fa-icon [icon]="['fas', 'folder-open']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
            {{ 'published-files.title' | translate }}
          </div>

          <button type="button" class="btn btn-sm btn-blue text-bold" (click)="navigateBack()">
            {{ 'button.back' | translate }}
          </button>
        </div>

        <div class="card-body">

          <p class="page-subtitle mb-4">{{ 'published-files.subtitle' | translate }}</p>

          @if (isLoading) {
            @for (item of skeletonItems; track item) {
              <div class="file-card card w-100 mb-2 file-card--skeleton">
                <div class="card-body p-3">
                  <div class="d-flex align-items-center gap-3">
                    <div class="skeleton file-icon-wrap" style="width:44px;height:44px;border-radius:10px;flex-shrink:0;"></div>
                    <div class="flex-grow-1">
                      <div class="skeleton mb-2" style="height:16px;width:50%;border-radius:6px;"></div>
                      <div class="skeleton" style="height:12px;width:30%;border-radius:6px;"></div>
                    </div>
                    <div class="d-flex gap-2">
                      <div class="skeleton" style="height:32px;width:74px;border-radius:8px;"></div>
                      <div class="skeleton" style="height:32px;width:90px;border-radius:8px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            }
          }

          @if (!isLoading && files.length === 0) {
            <div class="empty-state">
              <div class="empty-state__icon">
                <fa-icon [icon]="['fas', 'inbox']"></fa-icon>
              </div>
              <p class="empty-state__title">{{ 'published-files.empty-title' | translate }}</p>
              <p class="empty-state__text">{{ 'published-files.empty-text' | translate }}</p>
            </div>
          }

          @if (!isLoading && files.length > 0) {
            <div>
              @for (file of files; track file) {
                <div
                  class="file-card card w-100 mb-2 file-card--clickable"
                  [style.border-left-color]="getFileAccentColor(file.mimeType, file.fileName)"
                  (click)="downloadFile(file)"
                  tabindex="0"
                  role="button"
                  [attr.aria-label]="('button.download-file' | translate) + ': ' + file.fileName"
                  (keydown.enter)="downloadFile(file)"
                  (keydown.space)="downloadFile(file); $event.preventDefault()">
                  <div class="card-body p-3">
                    <div class="d-flex align-items-center gap-3 flex-wrap">
                      <div class="file-icon-wrap"
                        [style.background]="getFileAccentColor(file.mimeType, file.fileName) + '18'"
                        [style.color]="getFileAccentColor(file.mimeType, file.fileName)">
                        <fa-icon [icon]="getFileIcon(file.mimeType, file.fileName)" class="file-icon"></fa-icon>
                      </div>
                      <div class="file-info flex-grow-1 min-w-0">
                        <div class="file-name">{{ file.fileName }}</div>
                        @if (file.description) {
                          <div class="file-description">{{ file.description }}</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

        </div>
      </div>

    </div>
  </div>
</div>
